import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'project-admin-org-relation-delete-modal',
  template: require('./project.admin.orgs.relation.delete.modal.html')
})
export class ProjectAdminOrgRelationDeleteComponent implements OnInit {
  @Input() relationType: string;
  @Input() childProject: any;
  @Input() parentProject: any;

  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onClose: EventEmitter<any> = new EventEmitter();

  private targetName: string;

  isLoading = false;

  ngOnInit() {
    if (this.relationType === 'parent') {
      this.targetName = this.parentProject.name;
    }
  }

  deleteRelation() {
    this.onDelete.emit({
      parentId: this.parentProject,
      childId: this.childProject,
      type: this.relationType
    });
  }

  doClose() {
    this.onClose.emit();
  }
}
